/* ============================================================
   THE CABINET — behaviour for the pieces, the piece page and the bag.
   Loads after app.js. Never assumes an element exists.
   ============================================================ */
(function () {
  "use strict";
  var $ = function (id) { return document.getElementById(id); };
  var $$ = function (sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); };
  var fine = window.matchMedia && matchMedia("(hover:hover) and (pointer:fine)").matches;
  var still = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var es = function () { return (document.documentElement.lang || "en").slice(0, 2) === "es"; };

  /* ---------- language: every Liquid-rendered string carries its Spanish in data-es ---------- */
  var TYPES_ES = { ring: "Anillo", rings: "Anillos", bracelet: "Pulsera", bracelets: "Pulseras", pendant: "Colgante", pendants: "Colgantes",
    necklace: "Collar", necklaces: "Collares", earrings: "Aretes", earring: "Arete", studs: "Aretes", bangle: "Brazalete", chain: "Cadena" };
  function translate() {
    var s = es();
    $$("[data-es]").forEach(function (el) {
      if (el.dataset.en == null) el.dataset.en = el.textContent;
      el.textContent = s ? el.dataset.es : el.dataset.en;
    });
    $$("[data-es-label]").forEach(function (el) {
      if (el.dataset.enLabel == null) el.dataset.enLabel = el.getAttribute("aria-label") || "";
      el.setAttribute("aria-label", s ? el.dataset.esLabel : el.dataset.enLabel);
    });
    $$("#cab-filter .chip[data-f]:not([data-f=all]) > span").forEach(function (el) {
      if (el.dataset.en == null) el.dataset.en = el.textContent;
      var k = el.dataset.en.trim().toLowerCase();
      el.textContent = s && TYPES_ES[k] ? TYPES_ES[k] : el.dataset.en;
    });
    var add = $("pi-add");
    if (add) add.textContent = add.dataset[(s ? "es" : "en") + (add.disabled ? "Sold" : "Add")];
  }
  new MutationObserver(translate).observe(document.documentElement, { attributes: true, attributeFilter: ["lang"] });
  if (es()) translate();

  /* ---------- the grid filter ---------- */
  var filter = $("cab-filter");
  if (filter) {
    filter.addEventListener("click", function (e) {
      var b = e.target.closest("[data-f]"); if (!b) return;
      $$("[data-f]", filter).forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
      var n = 0, k = 0;
      $$("#pieces .piece").forEach(function (p) {
        var show = b.dataset.f === "all" || p.dataset.type === b.dataset.f;
        p.hidden = !show;
        if (show) { n++; p.style.setProperty("--i", k++ % 6); p.classList.remove("in"); void p.offsetWidth; p.classList.add("in"); }
      });
      var c = $("cab-count"); if (c) c.firstElementChild.textContent = n;
    });
  }

  /* ---------- the rail ---------- */
  var rail = $("cab-rail");
  if (rail) {
    var btns = $$("[data-rail]");
    var sync = function () {
      if (!btns.length) return;
      btns[0].disabled = rail.scrollLeft < 8;
      btns[1].disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 8;
      btns[0].parentNode.hidden = rail.scrollWidth <= rail.clientWidth + 8;
    };
    btns.forEach(function (b) {
      b.addEventListener("click", function () {
        var card = rail.querySelector(".piece");
        var step = card ? card.getBoundingClientRect().width + 24 : rail.clientWidth * .8;
        rail.scrollBy({ left: step * +b.dataset.rail, behavior: still ? "auto" : "smooth" });
      });
    });
    rail.addEventListener("scroll", function () { requestAnimationFrame(sync); }, { passive: true });
    addEventListener("resize", sync); sync();
  }

  /* ---------- film on hover, for a card that has film ---------- */
  if (fine && !still) {
    $$(".piece-img video[data-src]").forEach(function (v) {
      var a = v.closest("a");
      a.addEventListener("mouseenter", function () {
        if (!v.src) v.src = v.dataset.src;
        var p = v.play(); if (p && p.then) p.then(function () { v.classList.add("on"); }, function () {});
      });
      a.addEventListener("mouseleave", function () { v.classList.remove("on"); setTimeout(function () { v.pause(); }, 600); });
    });
  }

  /* ---------- the gallery ---------- */
  var track = $("pm-track");
  if (track) {
    var slides = $$(".pm-slide", track), thumbs = $$("#pm-thumbs [data-go]");
    var cur = 0;
    var go = function (i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false || still ? "auto" : "smooth" });
    };
    var mark = function (i) {
      if (i === cur && slides[i].dataset.seen) return;
      cur = i; slides[i].dataset.seen = 1;
      thumbs.forEach(function (t, k) { t.setAttribute("aria-current", String(k === i)); });
      slides.forEach(function (s, k) {
        var v = s.querySelector("video");
        if (!v) return;
        if (k === i) { v.muted = true; v.playsInline = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    };
    thumbs.forEach(function (t) { t.addEventListener("click", function () { go(+t.dataset.go); }); });
    track.addEventListener("scroll", function () {
      requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); });
    }, { passive: true });
    track.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { e.preventDefault(); go(cur + 1); }
      if (e.key === "ArrowLeft") { e.preventDefault(); go(cur - 1); }
    });
    mark(0);
    window.ARA_GO_MEDIA = function (id) {
      var k = slides.findIndex ? slides.findIndex(function (s) { return s.dataset.mid == id; }) : -1;
      if (k > -1) go(k);
    };

    /* a loupe: on a desk, hover a photograph to look closer */
    if (fine) {
      slides.forEach(function (s) {
        var img = s.querySelector("img.zoom"); if (!img) return;
        s.addEventListener("mousemove", function (e) {
          var r = s.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + "% " + ((e.clientY - r.top) / r.height * 100) + "%";
        });
        s.addEventListener("click", function () { s.classList.toggle("zooming"); });
        s.addEventListener("mouseleave", function () { s.classList.remove("zooming"); });
      });
    }

    /* the 3D model: Shopify's own viewer, turning slowly until touched */
    if ($$("model-viewer").length) {
      $$("model-viewer").forEach(function (mv) {
        mv.setAttribute("camera-controls", "");
        mv.setAttribute("auto-rotate", "");
        mv.setAttribute("rotation-per-second", "18deg");
        mv.setAttribute("interaction-prompt", "none");
        mv.setAttribute("shadow-intensity", "0.6");
        mv.setAttribute("exposure", "1.15");
        mv.setAttribute("environment-image", "neutral");
        if (still) mv.removeAttribute("auto-rotate");
      });
      if (window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([
          { name: "model-viewer-ui", version: "1.0", onLoad: function (err) {
              if (err || !window.Shopify.ModelViewerUI) return;
              $$("model-viewer").forEach(function (mv) { try { new Shopify.ModelViewerUI(mv); } catch (e) {} });
            } },
          { name: "shopify-xr", version: "1.0", onLoad: function (err) {
              if (err || !window.ShopifyXR) return;
              try { ShopifyXR.addModels(JSON.parse($("pm-models").textContent)); ShopifyXR.setupXRElements(); } catch (e) {}
            } }
        ]);
      }
    }
  }

  /* ---------- the accordion ---------- */
  $$(".acc-q").forEach(function (q) {
    q.addEventListener("click", function () { q.setAttribute("aria-expanded", String(q.getAttribute("aria-expanded") !== "true")); });
  });

  /* ---------- options and variants ---------- */
  var form = $("pi-form"), vjson = $("pi-variants");
  var variants = [];
  try { variants = vjson ? JSON.parse(vjson.textContent) : []; } catch (e) {}
  var money = function (cents) {
    var n = cents / 100;
    return "$" + n.toLocaleString("en-US", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };
  if (form && variants.length > 1) {
    var sets = $$(".pi-opt", form), sel = $("pi-variant"), add = $("pi-add");
    sets.forEach(function (fs) { fs.hidden = false; });
    var chosen = function () { return sets.map(function (fs) { var b = fs.querySelector("[aria-pressed=true]"); return b ? b.dataset.v : null; }); };
    var update = function () {
      var c = chosen();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === c[i]; }); });
      // cross out values that do not exist with the rest of the choice
      sets.forEach(function (fs, i) {
        $$(".chip", fs).forEach(function (b) {
          var ok = variants.some(function (x) { return x.available && x.options[i] === b.dataset.v && x.options.every(function (o, j) { return j === i || o === c[j]; }); });
          b.setAttribute("aria-disabled", String(!ok));
        });
        var lab = fs.querySelector("[data-sel]"); if (lab) lab.textContent = c[i] || "";
      });
      if (!v) return;
      if (sel) sel.value = v.id;
      $("pi-amount").textContent = money(v.price);
      var was = $("pi-was");
      if (v.compare_at_price > v.price) { if (!was) { was = document.createElement("s"); was.id = "pi-was"; $("pi-amount").after(was); } was.textContent = money(v.compare_at_price); }
      else if (was) was.remove();
      if (add) { add.disabled = !v.available; add.textContent = add.dataset[(es() ? "es" : "en") + (v.available ? "Add" : "Sold")]; }
      try { history.replaceState(null, "", location.pathname + "?variant=" + v.id); } catch (e) {}
      if (v.featured_media && window.ARA_GO_MEDIA) window.ARA_GO_MEDIA(v.featured_media.id);
    };
    sets.forEach(function (fs) {
      fs.addEventListener("click", function (e) {
        var b = e.target.closest(".chip"); if (!b) return;
        $$(".chip", fs).forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
        update();
      });
    });
    update();
  }

  /* ---------- add to bag without leaving the piece ---------- */
  if (form && window.fetch && window.ARA_CART) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = $("pi-add"), msg = $("pi-msg");
      if (!btn || btn.disabled) return;
      btn.disabled = true;
      fetch(ARA_CART.add + ".js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw r; return fetch(ARA_CART.url + ".js").then(function (c) { return c.json(); }); })
        .then(function (cart) {
          btn.disabled = false;
          var n = $("bag-n"), bag = $("bag");
          if (n) { n.textContent = cart.item_count; n.hidden = !cart.item_count; }
          if (bag) { bag.classList.remove("bump"); void bag.offsetWidth; bag.classList.add("bump"); bag.setAttribute("aria-label", "Bag, " + cart.item_count + " items"); }
          msg.innerHTML = (es() ? "En su bolsa. " : "In your bag. ") + '<a href="' + ARA_CART.url + '">' + (es() ? "Ver la bolsa y pagar" : "View the bag and check out") + " &rarr;</a>";
        })
        .catch(function () { btn.disabled = false; form.submit(); });
    });
  }

  /* ---------- ask Pamela about this piece ---------- */
  var ask = $("pi-ask");
  if (ask) {
    ask.addEventListener("click", function () {
      var fab = $("pam-fab"), panel = $("pam-panel"), input = $("pam-input");
      if (fab && panel && !panel.classList.contains("open")) fab.click();
      if (input) {
        input.value = (es() ? "Me interesa: " : "I'm interested in ") + ask.dataset.title + (es() ? ". ¿Me cuenta más?" : ". Can you tell me more?");
        setTimeout(function () { input.focus(); }, 380);
      }
    });
  }
})();
